<template>
<div class="chapter">
<div class="inner_page">
<section class="dedication" epub:type="dedication">
<p class="firstInSection">For Ivan and Barbara.</p>
<p>Thank you for all your support and kind comments.</p>
<p>You’re two very special people.</p>
<p>Stay well. Be good (well, at least try!).</p>
<p>See ya, kiddos!</p>
<p>Not forgetting our Madge who has been through a bad time but keeps plodding on – like the good ’un she is.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?676145cc